import { DefaultFooter } from '@ant-design/pro-components';
import React from 'react';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <DefaultFooter
      style={{
        background: 'none',
      }}
      copyright={
        <>
          <span>{`${currentYear} 广州钧隆科技有限公司`}</span>
          {' '}
          <a
            href="https://beiancx.miit.gov.cn/"
            target="_blank"
            rel="noreferrer"
            style={{ marginLeft: 10, color: 'rgba(0, 0, 0, 0.45)' }}
          >
            粤ICP备2025500663号
          </a>
        </>
      }
      links={[]}
    />
  );
};

export default Footer;
